import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { operationTypes } from '../utils/operationTypes';
import { riskCategorys } from '../utils/riskCategorys';


@Component({
  selector: 'app-people-related-to-the-ras',
  templateUrl: './people-related-to-the-ras.component.html',
  styleUrls: ['./people-related-to-the-ras.component.scss']
})
export class PeopleRelatedToTheRASComponent implements OnInit {

  @Input() data: { task: any };

  form: FormGroup = this.fb.group({
    otherPerson: [],
  });

  constructor(private readonly fb: FormBuilder) {}

  ngOnInit() {
    const { task } = this.data;

    const values = task.data;
    if (values) {
      this.form.patchValue(values);
    }
  }

}
